import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface IMenuStore {
  isOpen: boolean;
}

interface IAction {
  dispatch: (value: boolean) => void;
}

export const useMenuStore = create<IMenuStore & IAction>()(
  persist(
    (set) => ({
      isOpen: true,
      dispatch: (value: boolean) => set({ isOpen: value }),
    }),
    {
      name: 'menu-store',
    },
  ),
);
